import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
// Redux
import createStore from "app/redux/createStore";

// Redux Devtools
import DevTools from "app/components/common/DevTools";

import createHistory from "history/createBrowserHistory";
import { ConnectedRouter } from "react-router-redux";

import "./index.css";
import App from "./App";

const NODE_ENV = process.env.NODE_ENV;
const __DEV__ = NODE_ENV === "development";

const history = createHistory();
const store = createStore(history, {});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div style={{ height: "100%" }}>
        <HelmetProvider>
          <App />
        </HelmetProvider>

        {__DEV__ ? <DevTools /> : null}
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js